import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Quiz module configurations
export const LISTING_COLUMNS = [
  {
    id: 'subscriberName',
    label: 'Subscriber Name',
    width: '10%',
    align: 'left',
    dataKey: 'subscriberName',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'attempts',
    label: 'Attempts',
    width: '15%',
    align: 'left',
    dataKey: 'attempts',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'lastAttempt',
    label: 'Last Attempt',
    width: '10%',
    align: 'right',
    dataKey: 'lastAttempt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'maxScore',
    label: 'Max Score',
    width: '10%',
    align: 'right',
    dataKey: 'maxScore',
    sortable: true,
    type: CELL_DATA_TYPES.PERCENTAGE,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
];
